import Form from "views/Form";
import className from "classnames";
import { toast } from "react-hot-toast";
import { parseError } from "utils/helpers";
import { searchHandler } from "models/search";
import { dropdownItemSelector } from "models/form";
import { useDispatch, useSelector } from "react-redux";
import cardStyles from "styles/modules/Card.module.scss";
import formStyles from "components/Form/Form.module.scss";
import { formConfig } from "pages/AudioFiles/UploadAudio/formConfig";
import { useEffect, useLayoutEffect, useState } from "react";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import utilityStyles from "styles/modules/Utility.module.scss";
import { selectAllResults } from "features/search/searchSlice";
import { useCreateDIDMutation } from "features/did/didApiSlice";
import FormElement from "components/Form/FormElement/FormElement";
import { createSearchParams, useNavigate } from "react-router-dom";
import FormDropdown from "components/Form/FormDropdown/FormDropdown";
import {
  useUploadAudioFileMutation
} from "features/audioFiles/audioFilesApiSlice";

const form = new Form(formConfig);

const UploadAudio = () => {
  const [activeInput, setActiveInput] = useState("");

  const [formElements, setFormElements] = useState([]);
  const [formValidity, setFormValidity] = useState(false);

  const searchResults = useSelector(selectAllResults);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [uploadAudio, { isLoading }] = useUploadAudioFileMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("Upload Audio FIle"));
  }, [dispatch]);

  useLayoutEffect(() => {
    form.createFormElements();
    setFormElements(form.formElements);
  }, []);

  useEffect(() => {
    return () => {
      if (process.env.NODE_ENV === "production") {
        form.clear(); // will run once in production
        form.setConfig(formConfig);
      }
    };
  }, []);

  const submitFormHandler = async (e) => {
    e.preventDefault();

    const fileInput = document.querySelector('input[type="file"]');
    if (!fileInput.files.length) {
      toast.error("Please select a file to upload");
      return;
    }

    const file = fileInput.files[0];
    const category = form.getFormConfig().category.elementConfig.value;

    try {
      await uploadAudio({ file, category }).unwrap();
      toast.success("Upload successful");
      navigate({ pathname: "/audio_files", search: createSearchParams({ page: "1" }).toString() });

      window.location.reload();
    } catch (error) {
      const errorMessage = parseError(error);
      toast.error(errorMessage);
    }
  };

  const dropdownItemClickHandler = (key, item) => {
    dropdownItemSelector(key, item, form);
    setFormElements(form.formElements);
    setActiveInput("");
  };

  const inputChangeHandler = (e) => {
    const updatedInput = form.inputChangeHandler(e);

    setActiveInput(e.target.id);

    if (updatedInput) {

      if (e.target.id === "account_id") {
        searchHandler("/accounts", e.target.value, dispatch);
      }
      if (e.target.id === "call_billing_account_id") {
        searchHandler("/call_accounts", e.target.value, dispatch);
      }

      form.updateFormElement({ id: e.target.id, config: updatedInput });

      form.checkFormValidity();

      setFormElements(form.formElements);
      setFormValidity(form.isValid);
    }
  };

  return (
    <div
      className={`${utilityStyles.flexColumn} ${utilityStyles.itemsCenter} ${utilityStyles.justifyCenter}`}
    >
      <div
        className={className({
          [cardStyles.menu]: true,
          [utilityStyles.wFull]: true,
        })}
      >
        <h3>Select File to Upload</h3>
      </div>
      <div className={formStyles.wrapper}>
        <form className={formStyles.container} onSubmit={submitFormHandler}>
          {formElements.map((el, idx) => {
            const { title, elementType, elementConfig, ...config } = el.config;

            return (
              <div key={`el-group-${idx + 1}`} className={formStyles.group}>
                <FormElement
                  {...config}
                  title={title}
                  type={elementType}
                  id={elementConfig.id}
                  config={{
                    ...elementConfig,
                    onChange: inputChangeHandler,
                  }}
                />
                <FormDropdown
                  items={searchResults}
                  itemClickHandler={(item) =>
                    dropdownItemClickHandler(elementConfig.id, item)
                  }
                  visible={
                    activeInput === elementConfig.id && el.config.dropdown
                  }
                />
              </div>
            );
          })}
          <div className={formStyles.btn}>
            <button disabled={isLoading || !formValidity}>
              {isLoading ? "Uploading file..." : "Upload File"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UploadAudio;
